import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export default function LandingFooter() {
  return (
    <footer className="bg-navy-900 dark:bg-navy-950">
      <div className="max-w-6xl mx-auto px-4 py-12">

        {/* Row 1: Logo + Nav Links */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6">
          <div>
            <img
              src="/assets/logo/daily-reprieve-full.webp"
              alt="Daily Reprieve"
              className="h-8 w-auto"
            />
            <p className="text-slate-400 text-sm mt-1">Your recovery, one day at a time.</p>
          </div>

          <nav aria-label="Footer navigation">
            <ul role="list" className="flex flex-wrap gap-x-6 gap-y-2">
              <li>
                <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </nav>
        </div>

        {/* Row 2: Crisis Line */}
        <div className="bg-red-950/30 border border-red-900/50 rounded-lg px-4 py-3 mt-8 flex items-start gap-3">
          <ExclamationTriangleIcon className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" />
          <p className="text-red-300 text-sm">
            If you&apos;re in crisis: call or text{' '}
            <span className="font-bold text-red-200">988</span>
            {' '}(SAMHSA National Helpline) or text{' '}
            <span className="font-bold text-red-200">HOME</span>
            {' '}to{' '}
            <span className="font-bold text-red-200">741741</span>
          </p>
        </div>

        {/* Row 3: Copyright + Anonymity Note */}
        <div className="border-t border-navy-700 dark:border-navy-700 mt-8 pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-slate-500 text-xs">
            &copy; 2026 8:28 Solutions. All rights reserved.
          </p>
          <p className="text-slate-500 text-xs sm:text-right max-w-md">
            Daily Reprieve is not affiliated with AA, NA, or any 12-step organization. We respect the traditions of anonymity.
          </p>
        </div>

      </div>
    </footer>
  );
}
